import(/* webpackMode: "eager" */ "/home/coder/pubky-app-play/src/app/global-error.tsx");
